<qt-dialog>
  <div qtDialogTitle>{{ 'GNR_CREATE_TEMPLATE' | translate }}</div>

  <div qtDialogContent>
    <form [formGroup]="templateForm" class="template-form">
      <mat-form-field appearance="outline" class="name-field">
        <mat-label>{{ 'GNR_TEMPLATE_NAME' | translate }}</mat-label>
        <input
          matInput
          formControlName="name"
          [placeholder]="'GNR_TEMPLATE_NAME' | translate" />
        @if (nameControl.hasError('required')) {
          <mat-error>
            {{ 'ERR_FIELD_REQUIRED' | translate }}
          </mat-error>
        }
        @if (nameControl.hasError('templateNameExists')) {
          <mat-error>
            {{ 'ERR_NAME_EXISTS' | translate }}
          </mat-error>
        }
      </mat-form-field>

      <div class="template-content-section">
        @if (templateType === 'rtf') {
          <div class="editor-container">
            <quill-editor
              class="template-editor"
              ngDefaultControl
              formControlName="content"
              format="json"
              [modules]="quillModules"
              [required]="true"
              [bounds]="'self'"
              [placeholder]="'GNR_TEMPLATE_DETAILS' | translate">
            </quill-editor>
          </div>
        }
        @if (templateType === 'docs') {
          <qt-folder-structure-builder
            [initialStructure]="folderStructure"
            (structureChanged)="onFolderStructureChanged($event)" />
        }
      </div>

      <div class="button-container">
        <button mat-button type="button" (click)="cancel()">
          {{ 'GNR_CANCEL' | translate }}
        </button>
        <button
          mat-button
          class="qt-dialog-primary-button"
          type="button"
          [disabled]="
            templateForm.invalid ||
            isCreating ||
            (templateType === 'docs' && !folderStructure.length)
          "
          (click)="createAndPublishTemplate()">
          @if (isCreating) {
            <mat-icon>
              <mat-spinner diameter="18"></mat-spinner>
            </mat-icon>
          }
          {{ 'GNR_CREATE_AND_PUBLISH' | translate }}
        </button>
      </div>
    </form>
  </div>
</qt-dialog>
